"use client";

import { Layout } from 'antd';
import styles from './Demo.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import Image from 'next/image';
import demoImage from '../../../../public/assets/images/textRemoverDemo.png';
import { ArrowUpRightIcon } from '@/shared/constants/icon';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const IntcructionItemsData = [
  {
    id: 1,
    title: 'uploadPhoto',
    desc: 'uploadPhotoDesc'
  },
  {
    id: 2,
    title: 'pressBtn',
    desc: 'pressBtnDesc'
  },
  {
    id: 3,
    title: 'getResult',
    desc: 'getResultDesc'
  }
];

export const Demo = () => {
  const t = useTranslations('textRemover.demo');

  return (
    <Content className={styles.root}>
      <ScrollReveal variant="fadeUp" >
        <h1>{t('tryDemo')}</h1>
      </ScrollReveal>

      <section className={styles.root_content}>
        <ScrollReveal variant="fadeUp" className={styles.root_content_instruction} >
          {IntcructionItemsData.map(item => (
            <div key={item.id} className={styles.instr_root}>
              <div className={styles.instr_root_count}>{`${item.id}`}</div>
              <div className={styles.instr_root_text}>
                <h4>{t(item.title)}</h4>
                <h5>{t(item.desc)}</h5>
              </div>

              <span className={styles.arrow}>
                <ArrowUpRightIcon size={'3vw'} color={'var(--color-primary)'} />
              </span>
            </div>
          ))}
        </ScrollReveal>

        <ScrollReveal variant="fadeUp" className={styles.root_content_image} >
          <Image src={demoImage} alt="demo image" />
        </ScrollReveal>
      </section>
    </Content>
  );
};
